import React, { useEffect, useState } from 'react';
import { ModalPortal } from 'AppSrc/core/components/portals/modal-portal';
import { TickSvg } from 'AppSrc/core/components/common/svg-icons';
import { VFDropdownBase } from 'AppSrc/core/components/forms/form-base-components/v-f-dropdown-base';
import { OptionButton } from 'AppSrc/core/components/utility/option-button';
import PropTypes from 'prop-types';
import { getApproversGroupMembers, getApproverGroups } from 'AppSrc/core/approvers/approvers-queries';
import 'AppSrc/core/style/components/view-crq-screen/change-assignee-modal.css';

const SponsorIndividualApprovers = React.memo(({
  sponsorHandler,
}) => {
  const [selectedGroupId, setSelectedGroupId] = useState('');
  const [openMemberDialog, setOpenMemberDialog] = useState(false);
  const [updateData, setUpdateData] = useState('');
  const [displayMembers, setDisplayMembers] = useState([]);
  const [searchInput, setSearchInput] = useState('');
  const [groupMembers, setGroupMembers] = useState([]);
  const [selectedMember, setSelectedMember] = useState('');
  const [groupMap, setGroupMap] = useState([]);
  // sponsor group list if addsposor click groupslist api call it will list data

  useEffect(() => {
    if (selectedGroupId) {
      const network = 'mobile';
      getApproversGroupMembers(network, selectedGroupId).then((results) => {
        // DISPATCH HERE FREYJA
        setGroupMembers([...results]);
        setDisplayMembers([...results]);
      });
    }
  }, [selectedGroupId]);

  useEffect(() => {
    setUpdateData(updateData);
    if (updateData) {
      setSelectedGroupId(updateData ? updateData.id : '');
    }
  }, [updateData]);

  const onClickOpenIndividualModel = () => {
    setOpenMemberDialog(!openMemberDialog);
    getApproverGroups('mobile').then((result) => {
      setGroupMap([...result]);
    });
  };

  const onClickCloseIndiModel = () => {
    setOpenMemberDialog(!openMemberDialog);
  };
  const displayOptionss = groupMap.map((result) => ({
    text: result.name,
    value: result.id,
  }));

  const setApprovarEmailHandle = (param) => {
    setSelectedMember(param.email);
    sponsorHandler(param.email);
  };

  const searchHandler = (event) => {
    // Search function for filter array by searching any related text keywords
    const searchQuery = event.toLowerCase();
    const displayedName = groupMembers.filter((el) => {
      const searchValue = el.full_name.toLowerCase().includes(searchQuery);
      return searchValue;
    });

    setDisplayMembers(displayedName);
    setSearchInput(event);
  };

  // Sort group member in alphabetical order
  // memberList.sort((a, b) => a.full_name.localeCompare(b.full_name));

  return (
    <>
      <div className="outer-individual-wrap">
        <div className="individual-model-button ">
          <button className="btn-ind assign-to-me" type="button" onClick={onClickOpenIndividualModel}>Select Sponsor From Group</button>
        </div>
        {openMemberDialog
        && (
        <ModalPortal>
          <div className="change-assignee-modal">
            <div className="change-assignee-shadow" />
            <div className="change-assignee-inner">
              <div className="drop-down-group ind-wrap">
                <VFDropdownBase
                  displayOptions={displayOptionss}
                  updateValue={(value) => {
                    // get the group with the correct id out and pass it to setGroup
                    const group = groupMap.find((item) => item.id === value);
                    setUpdateData(group);
                  }}
                  fieldTitle="Select Individual Sponsor From Any Group"
                  placeholder="Select Groups"
                  name="selectGroup"
                  value={selectedGroupId}
                  // touched={touched}
                  // inlineErrors={inlineErrors}
                />
                { // Show selected members from redux store
                selectedMember && (
                <div className="display-selected-user">
                  <div className="search-drop">
                    {selectedMember}
                  </div>
                </div>
                )
                }
              </div>
              { groupMembers.length > 0 && (
              <div className="ressign-table-outer select-assignee-section select-assignee-section-change-coordinator">
                <h4 className="section-title">Individual Sponsor Members</h4>
                <div className="select-coordinator-table vf-table">
                  <div className="vf-table-head-container">
                    <div className="vf-table-head">
                      <div className="head-item">
                        <span className="head-text">
                          Name
                        </span>
                      </div>
                      <div className="head-item">
                        <span className="head-text">
                          ID
                        </span>
                      </div>
                    </div>
                  </div>
                  <>
                    { // Search div when default array length > 2
                      groupMembers.length > 2 && (
                        <div className="search-drop">
                          <input
                            className="Search-Input"
                            type="text"
                            onChange={(e) => searchHandler(e.target.value)}
                            placeholder=" Please Search Here..."
                            value={searchInput}
                          />
                          <div className={`no-result-msg ${displayMembers.length === 0 ? 'show-no-result' : 'hide-no-result'}`}><p>No Search Result Found</p></div>
                        </div>
                      )
                    }
                  </>
                  <div className="vf-table-body">
                    {
                      displayMembers.map((member) => {
                        const isSelected = member.email === selectedMember;
                        return (
                          <div
                            className={`vf-table-row-container${isSelected ? ' selected' : ''}`}
                            key={member.id}
                          >
                            <div className="vf-table-row">
                              <OptionButton
                                className="row-button"
                                onClick={setApprovarEmailHandle}
                                option={member}
                                // disabled={isSelected}
                              >
                                <div className="row-item">
                                  <span className="row-item-text">
                                    {member.full_name}
                                  </span>
                                </div>
                                <div className="row-item member-selected">
                                  <span className="row-item-text">
                                    {member.id}
                                  </span>
                                  {((selectedMember === member.email) === true) && (
                                  <div className="svg-wrapper">
                                    <TickSvg />
                                  </div>
                                  )}
                                </div>
                              </OptionButton>
                            </div>
                          </div>
                        );
                      })
                    }
                  </div>
                </div>
              </div>
              )}
              <div className="form-modal-options form-modal-options-spacemaker" />
              <div className="form-modal-options">
                <div className="side-left">
                  <button
                    type="button"
                    className="cancel-button"
                    onClick={onClickCloseIndiModel}
                  >
                    Close
                  </button>
                </div>
                <div className="side-right">
                  <button
                    type="button"
                    className="save-button"
                    // className={`save-button save-button-${showReAssignErr ? 'ready' : 'not-ready'}`}
                    // disabled={!showReAssignErr}
                    onClick={onClickCloseIndiModel}
                  >
                    Done
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ModalPortal>
        )}
      </div>
    </>
  );
});

SponsorIndividualApprovers.propTypes = {
// The value of display options can take on a variety of shapes here
  sponsorHandler: PropTypes.func,
};

export { SponsorIndividualApprovers };
